var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dropdown",
      staticClass: "filter-container",
      class: _vm.isOpen ? "active" : ""
    },
    [
      _c(
        "button",
        {
          staticClass: "filter-btn",
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.name) + "\n    "),
          _c("font-awesome-icon", {
            staticClass: "icon closed",
            attrs: { icon: "angle-down", fixedWidth: "" }
          }),
          _vm._v(" "),
          _c("font-awesome-icon", {
            staticClass: "icon open",
            attrs: { icon: "angle-up", fixedWidth: "" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-options" },
        [
          _c(
            "b-form-checkbox-group",
            {
              model: {
                value: _vm.myselection,
                callback: function($$v) {
                  _vm.myselection = $$v
                },
                expression: "myselection"
              }
            },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "b-form-checkbox",
                {
                  key: index,
                  attrs: { value: item.value },
                  on: { change: _vm.clickonit }
                },
                [_vm._v(_vm._s(item.text))]
              )
            }),
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e93046ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e93046ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropdownFilter.vue
// module id = uJf6
// module chunks = 1